module.exports = __webpack_public_path__ + "static/media/hyundai-motor-company-logo.de1733d2.svg";